import { cn } from "@drpcrd/utils/shared";
import { Skeleton } from "../skeleton";

type Props = {
  variant: "creator" | "brand";
};

/**
 * Loading skeleton for activity tabs displaying events and messages
 */
export const ActivityTabSkeleton = ({ variant }: Props) => (
  <div
    className={cn(
      "flex h-screen w-full flex-col bg-white pt-3",
      variant === "creator" ? "px-1" : "px-3",
    )}
  >
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-2">
        <Skeleton className="h-2 w-2" />
        <Skeleton className="h-[22px] w-1/2" />
      </div>
      <div className="flex items-center gap-2">
        <Skeleton className="h-2 w-2" />
        <Skeleton className="h-[22px] w-1/2" />
      </div>
      <div className="flex items-center gap-2">
        <Skeleton className="h-2 w-2" />
        <Skeleton className="h-[22px] w-1/2" />
      </div>
    </div>
    <div className="mt-4 flex w-full flex-row-reverse items-center gap-2">
      <Skeleton className="h-4 w-4 rounded-full" />
      <Skeleton className="h-[68px] w-1/2 rounded-b-2xl rounded-tl-2xl rounded-tr-none" />
    </div>
    <div className="mt-2 flex w-full items-center gap-2">
      <Skeleton className="h-4 w-4 rounded-full" />
      <Skeleton className="h-[68px] w-1/2 rounded-b-2xl rounded-tl-none rounded-tr-2xl" />
    </div>
    <div className="mt-4 flex items-center gap-2">
      <Skeleton className="h-2 w-2" />
      <Skeleton className="h-[22px] w-1/2" />
    </div>
    <div className="mt-2 flex w-full flex-row-reverse items-center gap-2">
      <Skeleton className="h-4 w-4 rounded-full" />
      <Skeleton className="h-[68px] w-1/2 rounded-b-2xl rounded-tl-2xl rounded-tr-none" />
    </div>
    <div className="mt-2 flex w-full items-center gap-2">
      <Skeleton className="h-4 w-4 rounded-full" />
      <Skeleton className="h-[68px] w-1/2 rounded-b-2xl rounded-tl-none rounded-tr-2xl" />
    </div>
  </div>
);
